/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Wallet = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M1 6.37706L1.01383 6.37795C1.00469 6.29558 1 6.21187 1 6.12706C1 4.89415 1.89743 3.84469 3.11539 3.6533L20 1L20 6.87706H23V22.8771H1V6.37706ZM2.50002 21.3771H21.5V17.8761L18 17.8771C16.3432 17.8771 15 16.5339 15 14.8771C15 13.2202 16.3432 11.8771 18 11.8771L21.5 11.8761V8.37706H2.50002V21.3771ZM21.5 13.3771H18C17.2203 13.3771 16.5796 13.9719 16.5069 14.7326L16.5 14.8771C16.5 15.7055 17.1716 16.3771 18 16.3771H21.5V13.3771ZM18.5 2.75306L3.34824 5.13511C2.89742 5.20596 2.55612 5.56997 2.50628 6.0144L2.5 6.12706C2.5 6.54127 2.83579 6.87706 3.25 6.87706H18.5V2.75306Z"
                        fill={color}
                    />
                </svg>
        );
    };
